// extracted by mini-css-extract-plugin
module.exports = {"display":"createWallet_display__PbdFe"};